import React from 'react';
import { StarIcon } from 'lucide-react';
export const GoogleReviewBadge = () => {
  return <div className="inline-flex items-center bg-white/10 backdrop-blur-sm border border-white/20 rounded-full py-1.5 px-3 shadow-lg hover:bg-white/15 transition-colors duration-300 group" data-id="element-230">
      <div className="flex -space-x-1.5 mr-2" data-id="element-231">
        {/* Small profile circles representing reviewers */}
        {[...Array(3)].map((_, i) => <div key={i} className="w-6 h-6 rounded-full border-2 border-black bg-gradient-to-br from-gray-100 to-gray-300 flex items-center justify-center text-[8px] font-bold text-black overflow-hidden" style={{
        zIndex: 3 - i,
        backgroundImage: i === 0 ? 'url(https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80)' : i === 1 ? 'url(https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80)' : 'url(https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }} data-id="element-232" />)}
        <div className="w-6 h-6 rounded-full border-2 border-black bg-black flex items-center justify-center text-[8px] font-bold text-white" style={{
        zIndex: 0
      }} data-id="element-233">
          +52
        </div>
      </div>
      <div className="flex flex-col items-start" data-id="element-234">
        <div className="flex items-center" data-id="element-235">
          <div className="flex" data-id="element-236">
            {[...Array(5)].map((_, i) => <StarIcon key={i} size={12} className="text-[#FFD700] fill-[#FFD700] mr-0.5" data-id="element-237" />)}
          </div>
          <span className="text-white font-semibold text-xs ml-1" data-id="element-238">5.0</span>
        </div>
        <div className="flex items-center" data-id="element-239">
          <span className="text-white/80 text-[10px]" data-id="element-240">
            55 reviews op Google
          </span>
        </div>
      </div>
    </div>;
};